import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CognitoAuthService } from './cognito-auth.service';

@UntilDestroy()
@Component({
    selector: 'ngx-auth-callback',
    standalone: true,
    template: `
        <div class="d-flex justify-content-center align-items-center" style="height: 100vh;">
            <div class="text-center">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Autenticazione in corso...</span>
                </div>
                <p class="mt-3">Autenticazione in corso...</p>
            </div>
        </div>
    `
})
export class AuthCallbackComponent implements OnInit {
    private readonly _route = inject(ActivatedRoute);
    private readonly _router = inject(Router);
    private readonly _authService = inject(CognitoAuthService);

    ngOnInit(): void {
        // Ottieni il code dai query params
        this._route.queryParams.pipe(untilDestroyed(this)).subscribe((params) => {
            const code = params['code'];
            const error = params['error'];

            if (error) {
                // eslint-disable-next-line no-console
                console.error("Errore durante l'autenticazione:", error);
                this._router.navigate(['/']);
                return;
            }

            if (!code) {
                // eslint-disable-next-line no-console
                console.error('Code non trovato nei query params');
                this._router.navigate(['/']);
                return;
            }

            // Scambia il code con i token
            this._authService
                .handleCallback(code)
                .pipe(untilDestroyed(this))
                .subscribe({
                    next: () => {
                        // Ottieni l'URL di redirect salvato o vai alla home
                        const redirectUrl = sessionStorage.getItem('cognito_redirect_url') || '/';
                        sessionStorage.removeItem('cognito_redirect_url');
                        this._router.navigate([redirectUrl]);
                    },
                    error: (err: unknown) => {
                        // eslint-disable-next-line no-console
                        console.error('Errore nello scambio del code:', err);
                        this._router.navigate(['/']);
                    }
                });
        });
    }
}
